import React from 'react';
import AllRecommendations from '../components/AllRecommendations';

const RecommendationPage = () => {
    return (
        <AllRecommendations />
    )
}

export default RecommendationPage;